import { getTypes } from "./getTypes";

export const typesAPI = {
  getTypes,
};

export type TypesAPI = typeof typesAPI;
